//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dialogMixin from '@/mixin/dialog.js';
import { mapGetters } from 'vuex';

export default {
  name: 'SkillAdd',
  mixins: [dialogMixin],
  props: {
    updatePageData: { type: Function, default: () => {} },
    isEdit: { type: Boolean, default: false },
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      loadingBtn: false,
      addForm: {
        skillIds: [],
      },
    };
  },
  computed: {
    ...mapGetters('common', ['skillTree']),
  },
  methods: {
    handleAddSkill(payload) {
      this.$api('userAddSkill', payload).then(() => {
        this.$message.success('新增成功!');
        this.updatePageData();
      });
    },
    onSkillChange(selected) {
      this.addForm.skillIds = selected;
    },
    onSave() {
      this.$refs['addForm'].validate(valid => {
        if (!valid) {
          return null;
        }
        const payload = this.addForm;
        this.handleAddSkill(payload);
        this.close();
      });
    },
    onClose() {
      this.$refs.addForm.resetFields();
      this.close();
    },
    onOpen() {
      this.addForm = Object.assign({}, this.item);
    },
  },
};
